import { toast } from 'react-toastify';
import { apiPayment } from '../../../api/apiPayment.api';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { apiSubscription } from '../../../api/apiSubscription.api';

export function CancelSubscription({ onSuccess }) {
  const axiosPrivate = useAxiosPrivate();

  const handleCancelSubscription = async () => {
    try {
      await apiSubscription.cancel(axiosPrivate);
      onSuccess?.();
      toast.info(
        'Подписка Myta Premium отменена. Вы сможете пользоваться Premium функциями до конца текущего периода. Мы всегда будем рады вашему возвращению!',
      );
    } catch (error) {
      const message = error?.response?.data?.message || error.message;
      toast.error(message);
    } finally {
    }
  };

  return (
    <>
      <button
        onClick={handleCancelSubscription}
        type="button"
        className={`font-medium text-sm text-white disabled:cursor-not-allowed`}
      >
        Отменить подписку
      </button>
    </>
  );
}
